module.exports = "/images/herculift-logo-full.png?33006382dc8b5f7973bc661fda172223";